<!--<div *ngIf="options?.chartHeader != null">{{ options.chartHeader }}</div>-->



<ngx-charts-line-chart style="padding:1px; fill: #2B2B2B;"
                       [view]="view | async"
                       [scheme]="options?.colourScheme ?? scheme"
                       [legend]="legend"
                       [legendTitle]="legendTitle"
                       [showXAxisLabel]="showXAxisLabel"
                       [showYAxisLabel]="showYAxisLabel"
                       [xAxis]="xAxis"
                       [yAxis]="yAxis"
                       [xAxisLabel]="options?.xAxisLabel"
                       [yAxisLabel]="options?.yAxisLabel"
                       [timeline]="timeline"
                       [results]="_results | async"
                       [curve]="curve"
                       (select)="onSelect($event)"
                       (activate)="onActivate($event)"
                       (deactivate)="onDeactivate($event)"
                       [xAxisTickFormatting]="options?.xAxisTickFormatting">
  <ng-template *ngIf="eveTooltipTemplate != null" #tooltipTemplate let-model="model">
    <ng-container *ngTemplateOutlet="eveTooltipTemplate;context:{model}"></ng-container>
  </ng-template>

  <ng-template *ngIf="eveSeriesTooltipTemplate != null" #seriesTooltipTemplate let-model="model">
    <ng-container *ngTemplateOutlet="eveSeriesTooltipTemplate;context:{model}"></ng-container>
  </ng-template>
</ngx-charts-line-chart>


<div [innerHTML]="legendStyles | async"></div>


